import { render, staticRenderFns } from "./LawNoteToBeOnInvoiceList.vue?vue&type=template&id=fade206c&"
import script from "./LawNoteToBeOnInvoiceList.vue?vue&type=script&lang=js&"
export * from "./LawNoteToBeOnInvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./LawNoteToBeOnInvoiceList.vue?vue&type=style&index=0&id=fade206c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports